<ion-header>
  <ion-toolbar>
    <ion-title>{{ 'Smart venues' | translate }}</ion-title>

    <ion-buttons slot="start">
      <ion-back-button defaultHref="/"></ion-back-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-refresher #refresher (ionRefresh)="doRefresh()" slot="fixed">
    <ion-refresher-content></ion-refresher-content>
  </ion-refresher>
  
  @defer (when loaded()) {
    @if (venues().length) {
      <ion-list class="content-width">
        @for (venue of venues(); let i = $index; track i) {
          <ion-item button [routerLink]="[venue._id]" routerLinkActive="router-link-active">
            <ion-label>{{ venue.venueName }}</ion-label>
          </ion-item>      
        }
        
      </ion-list>
    } @else {
      <app-empty-page text="{{'You don\'t have any smart venues' | translate}}" iconName="home"></app-empty-page>
    }
  } @loading (minimum 0.6s) {
    <ion-loading isOpen="true" name="crescent"></ion-loading>
  }

  <ion-fab vertical="bottom" horizontal="end" slot="fixed">
    <ion-fab-button (click)="createVenue()">
      <ion-icon name="add"></ion-icon>
    </ion-fab-button>
  </ion-fab>
</ion-content>